"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = require("./Spinner.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Spinner = function Spinner(_ref) {
  var size = _ref.size,
      color = _ref.color;
  var sizes = {
    large: {
      width: 62,
      height: 62
    },
    medium: {
      width: 45,
      height: 45
    },
    small: {
      width: 24,
      height: 24
    }
  };
  return _react["default"].createElement(_Spinner.StyleBase, {
    color: color
  }, _react["default"].createElement("svg", {
    width: sizes[size].width,
    height: sizes[size].height,
    viewBox: "0 0 62 62",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    id: "fill-spinner",
    transform: "translate(-476.000000, -5365.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(476.000000, 5365.000000)"
  }, _react["default"].createElement("path", {
    d: "M31,0 C13.8717172,0 0,13.8717172 0,31 C0,33.0666667 1.69090909,34.7575758 3.75757576,34.7575758 C5.82424242,34.7575758 7.51515152,33.0666667 7.51515152,31 C7.51515152,18.0363636 18.0363636,7.51515152 31,7.51515152 C43.9636364,7.51515152 54.4848485,18.0363636 54.4848485,31 C54.4848485,43.9636364 43.9636364,54.4848485 31,54.4848485 C28.9333333,54.4848485 27.2424242,56.1757576 27.2424242,58.2424242 C27.2424242,60.3090909 28.9333333,62 31,62 C48.1282828,62 62,48.1282828 62,31 C62,13.8717172 48.1282828,0 31,0 Z"
  }))))));
};

Spinner.propTypes = {
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  color: _propTypes["default"].bool
};
Spinner.defaultProps = {
  size: 'meduim',
  color: false
};
var _default = Spinner;
exports["default"] = _default;